import { Injectable } from '@angular/core';
import { DOC_ORIENTATION, NgxImageCompressService } from 'ngx-image-compress';

@Injectable({
  providedIn: 'root'
})
export class CompressImageService {
  private excludedMimeTypes = ['image/tif', 'image/tiff'];

  constructor(private imageCompress: NgxImageCompressService) {}

  buildBase64(base64Raw: string, mimeType: string) {
    const base64RawSanitized = this.extractBase64BodyFromMetadata(base64Raw);
    return `data:${mimeType};base64,${base64RawSanitized}`;
  }

  compressBase64Image(base64: string) {
    const mimeType = this.extractMimeTypeFromMetadata(base64);
    if (this.excludedMimeTypes.includes(mimeType)) {
      return Promise.resolve(base64);
    }
    return this.imageCompress.compressFile(base64, DOC_ORIENTATION.Up, 80, 50);
  }

  extractBase64BodyFromMetadata(base64: string) {
    return base64.replace(/^data:(.*;base64,)?/, '');
  }

  extractMimeTypeFromMetadata(base64: string) {
    const mimeTypeSearch = base64.match(
      /data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/
    );
    return mimeTypeSearch && mimeTypeSearch[1];
  }
}
